import { render, staticRenderFns } from "./ActivityFillableTextContainer.vue?vue&type=template&id=5f3514bf&scoped=true"
import script from "./ActivityFillableTextContainer.vue?vue&type=script&lang=ts"
export * from "./ActivityFillableTextContainer.vue?vue&type=script&lang=ts"
import style0 from "./ActivityFillableTextContainer.vue?vue&type=style&index=0&id=5f3514bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3514bf",
  null
  
)

/* custom blocks */
import block0 from "./ActivityFillableTextContainer.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports